"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/collapse/style/index.js
// module id = 287
// module chunks = 1